var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("editor", {
        key: _vm.id,
        ref: "editor",
        attrs: {
          options: _vm.options,
          initialValue: _vm.initialText,
          imagePath: _vm.imagePath,
          imageUpload: _vm.imageUpload,
          custom_directory: _vm.custom_directory,
          initialEditType: "wysiwyg"
        },
        on: { change: _vm.onEditorChange, load: _vm.onEditorLoad },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "50vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.hideImagePickerModal()
            }
          },
          model: {
            value: _vm.image_picker,
            callback: function($$v) {
              _vm.image_picker = $$v
            },
            expression: "image_picker"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "div",
                [
                  _c(
                    "q-tabs",
                    {
                      attrs: { animated: "" },
                      model: {
                        value: _vm.selectedTab,
                        callback: function($$v) {
                          _vm.selectedTab = $$v
                        },
                        expression: "selectedTab"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "device",
                          label: _vm.$q.platform.is.desktop
                            ? "" + _vm.$t("image_from_device")
                            : "",
                          icon: "fal fa-tablet-android"
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "web",
                          label: _vm.$q.platform.is.desktop
                            ? "" + _vm.$t("image_from_web")
                            : "",
                          icon: "fal fa-globe-americas"
                        },
                        slot: "title"
                      }),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "device" }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("insert_image_from_device")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "file-picker",
                              on: { click: _vm.imageFilePicker }
                            },
                            [
                              _c(
                                "q-field",
                                {
                                  staticClass: "q-ma-sm",
                                  attrs: {
                                    type: "file",
                                    icon: "fal fa-cloud-upload-alt"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.$t(_vm.image_file_name)))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("small", [
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("accepted_image_file_types"))
                              )
                            ])
                          ]),
                          _c("q-input", {
                            staticClass: "q-my-sm",
                            attrs: {
                              "float-label": _vm.$t("image_description"),
                              placeholder: _vm.$t("my_image")
                            },
                            model: {
                              value: _vm.image_file_description,
                              callback: function($$v) {
                                _vm.image_file_description = $$v
                              },
                              expression: "image_file_description"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "web" }
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("insert_image_from_web")))
                          ]),
                          _c("q-input", {
                            staticClass: "q-my-sm",
                            attrs: {
                              "float-label": _vm.$t("image_link"),
                              placeholder: "http://image.com/image.jpg"
                            },
                            model: {
                              value: _vm.web_image_link,
                              callback: function($$v) {
                                _vm.web_image_link = $$v
                              },
                              expression: "web_image_link"
                            }
                          }),
                          _c("small", [
                            _c("em", [
                              _vm._v(_vm._s(_vm.$t("web_image_formats")))
                            ])
                          ]),
                          _c("q-input", {
                            staticClass: "q-my-sm",
                            attrs: {
                              "float-label": _vm.$t("image_description"),
                              placeholder: _vm.$t("my_image")
                            },
                            model: {
                              value: _vm.web_image_description,
                              callback: function($$v) {
                                _vm.web_image_description = $$v
                              },
                              expression: "web_image_description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("q-btn", {
                    staticClass: "q-mx-sm",
                    attrs: { color: "positive", label: _vm.$t("insert_image") },
                    on: {
                      click: function($event) {
                        return _vm.insertImage(_vm.selectedTab)
                      }
                    }
                  }),
                  _c("q-btn", {
                    staticClass: "q-mx-sm",
                    attrs: { color: "negative", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.image_picker = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }